// src/components/common/Breadcrumbs.tsx
import { Link, useLocation } from "react-router-dom";
import { twMerge } from "tailwind-merge";

interface BreadcrumbsProps {
  transparent?: boolean;
}

export default function Breadcrumbs({ transparent = false }: BreadcrumbsProps) {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter(Boolean);

  return (
    <nav className={twMerge(
      "breadcrumbs px-4 py-2 text-sm text-base-content",
      transparent ? "bg-base-50/40 backdrop-blur-sm" : "bg-base-100"
    )}>
      <ul className="flex gap-2">
        <li>
          <Link className="hover:underline" to="/">
            Home
          </Link>
        </li>
        {pathnames.map((segment) => {
          const label = segment
            .replace(/-/g, " ")
            .replace(/\b\w/g, (c) => c.toUpperCase());

          return (
            <li key={segment}>
              <span className="text-base-content/70">{label}</span>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
